import cookies, { CookieAttributes } from 'js-cookie'
import psl, { ParsedDomain } from 'psl'
import { hasWindow } from '../../utils'

const DO_NOT_TRACK_KEY = 'do-not-track'

export const setDoNotTrack = (doNotTrack: boolean): void => {
  if (!hasWindow()) {
    return
  }

  const opts: CookieAttributes = {}
  const { domain } = psl.parse(window.location.hostname) as ParsedDomain
  if (domain) {
    opts.domain = domain
  }

  cookies.set(DO_NOT_TRACK_KEY, JSON.stringify(doNotTrack), opts)
}

export const getDoNotTrack = (): boolean => {
  const doNotTrackCookie = cookies.get(DO_NOT_TRACK_KEY)
  if (!doNotTrackCookie) {
    const browserDoNotTrackSetting = hasWindow() ? navigator.doNotTrack === '1' : false
    setDoNotTrack(browserDoNotTrackSetting)
    return browserDoNotTrackSetting
  }
  return JSON.parse(doNotTrackCookie)
}
